import React from "react";
import { createRoot } from "react-dom/client";
import OperatorItData from "./OperatorItData";
import { testimonialsType } from "../../common/types/product";

declare global {
	interface Window {
		renderOperatorItData: unknown;
	}
}

export function renderOperatorItData(
	rootId: string,
	title: string,
	subscribeLink: string,
	testimonials: testimonialsType,
) {
	const root = createRoot(document.getElementById(rootId)!);
	root.render(
		<OperatorItData
			packageName={title}
			subscribeLink={subscribeLink}
			testimonials={testimonials}
		/>,
	);
}

window.renderOperatorItData = renderOperatorItData;
